
// //frontend/src/pages/AdminDashboard.jsx
// import React, { useState, useEffect } from "react";
// import axios from "axios";

// export default function AdminDashboard({ token }) {
//   const [students, setStudents] = useState([]);
//   const [contents, setContents] = useState([]);
//   const [form, setForm] = useState({ page: "", section: "", content: "" });

//   const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

//   // Fetch students
//   useEffect(() => {
//     if (!token) return;
//     axios
//       .get(`${API_BASE}/api/admin/students`, {
//         headers: { Authorization: `Bearer ${token}` },
//       })
//       .then((res) => setStudents(res.data))
//       .catch((err) => {
//         console.error("Failed to fetch students:", err);
//       });
//   }, [token]);

//   // Fetch all content (optional: filter by page)
//   const fetchContent = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/api/content/about`); // default fetch "about"
//       setContents(res.data);
//     } catch (err) {
//       console.error("Failed to fetch content:", err);
//     }
//   };

//   useEffect(() => {
//     fetchContent();
//   }, []);

//   // Save new content
//   const saveContent = async () => {
//     try {
//       await axios.post(
//         `${API_BASE}/api/content`,
//         form,
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       alert("Content saved ✅");
//       fetchContent();
//       setForm({ page: "", section: "", content: "" });
//     } catch (err) {
//       console.error("Save content error:", err);
//       alert("Failed to save content.");
//     }
//   };

//   // Delete content
//   const deleteContent = async (id) => {
//     try {
//       await axios.delete(`${API_BASE}/api/content/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       alert("Deleted ✅");
//       fetchContent();
//     } catch (err) {
//       console.error("Delete content error:", err);
//       alert("Failed to delete content.");
//     }
//   };

//   return (
//     <div className="p-6">
//       {/* ===================== Student Section ===================== */}
//       <h2 className="text-2xl font-bold text-primary mb-4">Admin Dashboard</h2>
//       <table className="w-full border-collapse border mb-8">
//         <thead>
//           <tr className="bg-secondary text-base">
//             <th className="border p-2">Name</th>
//             <th className="border p-2">Email</th>
//             <th className="border p-2">Test Score</th>
//             <th className="border p-2">Scholarship</th>
//             <th className="border p-2">Final Fee</th>
//             <th className="border p-2">Payment</th>
//           </tr>
//         </thead>
//         <tbody>
//           {students.map((s) => (
//             <tr key={s._id}>
//               <td className="border p-2">{s.name}</td>
//               <td className="border p-2">{s.email}</td>
//               <td className="border p-2">{s.testScore || "-"}</td>
//               <td className="border p-2">{s.scholarshipTier || "-"}</td>
//               <td className="border p-2">{s.finalFee || "-"}</td>
//               <td className="border p-2">{s.paymentStatus}</td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* ===================== Content Management ===================== */}
//       <h2 className="text-2xl font-bold text-primary mb-4">Manage Page Content</h2>
//       <div className="space-y-2 mb-6">
//         <input
//           className="border p-2 w-full"
//           placeholder="Page (about, fees, home)"
//           value={form.page}
//           onChange={(e) => setForm({ ...form, page: e.target.value })}
//         />
//         <input
//           className="border p-2 w-full"
//           placeholder="Section (mission, vision, etc.)"
//           value={form.section}
//           onChange={(e) => setForm({ ...form, section: e.target.value })}
//         />
//         <textarea
//           className="border p-2 w-full h-24"
//           placeholder="Content text"
//           value={form.content}
//           onChange={(e) => setForm({ ...form, content: e.target.value })}
//         />
//         <button
//           onClick={saveContent}
//           className="bg-primary text-secondary px-4 py-2 rounded font-bold"
//         >
//           Save Content
//         </button>
//       </div>

//       {/* ===================== Content List ===================== */}
//       <h3 className="text-xl font-bold text-primary mb-2">Existing Content</h3>
//       <table className="w-full border-collapse border">
//         <thead>
//           <tr className="bg-secondary text-base">
//             <th className="border p-2">Page</th>
//             <th className="border p-2">Section</th>
//             <th className="border p-2">Content</th>
//             <th className="border p-2">Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {contents.map((c) => (
//             <tr key={c._id}>
//               <td className="border p-2">{c.page}</td>
//               <td className="border p-2">{c.section}</td>
//               <td className="border p-2">{c.content}</td>
//               <td className="border p-2">
//                 <button
//                   onClick={() => deleteContent(c._id)}
//                   className="bg-red-600 text-white px-3 py-1 rounded"
//                 >
//                   Delete
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// frontend/src/pages/AdminDashboard.jsx
import React, { useState, useEffect } from "react";
import api from "../utils/api"; // ✅ CHANGED

export default function AdminDashboard({ token }) {
  const [students, setStudents] = useState([]);
  const [contents, setContents] = useState([]);
  const [form, setForm] = useState({ page: "", section: "", content: "" });

  // Fetch students
  useEffect(() => {
    if (!token) return;

    api
      .get("/api/admin/students") // ✅ CHANGED
      .then((res) => setStudents(res.data))
      .catch((err) => {
        console.error("Failed to fetch students:", err);
      });
  }, [token]);

  // Fetch all content
  const fetchContent = async () => {
    try {
      const res = await api.get("/api/content/about"); // ✅ CHANGED
      setContents(res.data);
    } catch (err) {
      console.error("Failed to fetch content:", err);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  // Save new content
  const saveContent = async () => {
    try {
      await api.post("/api/content", form); // ✅ CHANGED

      alert("Content saved ✅");
      fetchContent();
      setForm({ page: "", section: "", content: "" });

    } catch (err) {
      console.error("Save content error:", err);
      alert("Failed to save content.");
    }
  };

  // Delete content
  const deleteContent = async (id) => {
    try {
      await api.delete(`/api/content/${id}`); // ✅ CHANGED

      alert("Deleted ✅");
      fetchContent();

    } catch (err) {
      console.error("Delete content error:", err);
      alert("Failed to delete content.");
    }
  };

  return (
    <div className="p-6">
      {/* ===================== Student Section ===================== */}
      <h2 className="text-2xl font-bold text-primary mb-4">Admin Dashboard</h2>

      <table className="w-full border-collapse border mb-8">
        <thead>
          <tr className="bg-secondary text-base">
            <th className="border p-2">Name</th>
            <th className="border p-2">Email</th>
            <th className="border p-2">Test Score</th>
            <th className="border p-2">Scholarship</th>
            <th className="border p-2">Final Fee</th>
            <th className="border p-2">Payment</th>
          </tr>
        </thead>
        <tbody>
          {students.map((s) => (
            <tr key={s._id}>
              <td className="border p-2">{s.name}</td>
              <td className="border p-2">{s.email}</td>
              <td className="border p-2">{s.testScore || "-"}</td>
              <td className="border p-2">{s.scholarshipTier || "-"}</td>
              <td className="border p-2">{s.finalFee || "-"}</td>
              <td className="border p-2">{s.paymentStatus}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===================== Content Management ===================== */}
      <h2 className="text-2xl font-bold text-primary mb-4">Manage Page Content</h2>

      <div className="space-y-2 mb-6">
        <input
          className="border p-2 w-full"
          placeholder="Page (about, fees, home)"
          value={form.page}
          onChange={(e) => setForm({ ...form, page: e.target.value })}
        />

        <input
          className="border p-2 w-full"
          placeholder="Section (mission, vision, etc.)"
          value={form.section}
          onChange={(e) => setForm({ ...form, section: e.target.value })}
        />

        <textarea
          className="border p-2 w-full h-24"
          placeholder="Content text"
          value={form.content}
          onChange={(e) => setForm({ ...form, content: e.target.value })}
        />

        <button
          onClick={saveContent}
          className="bg-primary text-secondary px-4 py-2 rounded font-bold"
        >
          Save Content
        </button>
      </div>

      {/* ===================== Content List ===================== */}
      <h3 className="text-xl font-bold text-primary mb-2">Existing Content</h3>

      <table className="w-full border-collapse border">
        <thead>
          <tr className="bg-secondary text-base">
            <th className="border p-2">Page</th>
            <th className="border p-2">Section</th>
            <th className="border p-2">Content</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>

        <tbody>
          {contents.map((c) => (
            <tr key={c._id}>
              <td className="border p-2">{c.page}</td>
              <td className="border p-2">{c.section}</td>
              <td className="border p-2">{c.content}</td>
              <td className="border p-2">
                <button
                  onClick={() => deleteContent(c._id)}
                  className="bg-red-600 text-white px-3 py-1 rounded"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}